import Quill from "quill";

const QuillLink = Quill.import("blots/inline");
class Link extends QuillLink {
  static className = "ql-link";
  static blotName = "link";
  static tagName = "A";

  static create(value) {
    const linkData = {};
    linkData.href = value.href || value;
    linkData.text = value.text || value;
    let node = super.create(linkData);
    node.href = this.sanitize(linkData);
    node.setAttribute("target", "_blank");
    try {
      const href = new URL(node.href);
      if (href?.host === window.location.host) {
        node.setAttribute("target", "_self");
      }
    } catch (e) {
      console.info("url error", e);
    }
    return node;
  }

  static formats(node) {
    return {
      href: node.getAttribute("href"),
      text: node.innerText
    };
  }

  static sanitize(value) {
    let url = value.href;
    const anchor = document.createElement("a");
    anchor.href = url;
    if (
      ["https:", "http:", "mailto:"].includes(anchor.protocol) &&
      typeof url === "string"
    ) {
      if (!url?.startsWith(anchor.protocol) && !url?.startsWith("#")) {
        return `https://${url}`;
      }
      return url;
    }
    return "about:blank";
  }
}

export { Link };
